"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.red50 = "#ffebee";
exports.red100 = "#ffcdd2";
exports.red200 = "#ef9a9a";
exports.red300 = "#e57373";
exports.red400 = "#ef5350";
exports.red500 = "#f44336";
exports.red600 = "#e53935";
exports.red700 = "#d32f2f";
exports.red800 = "#c62828";
exports.red900 = "#b71c1c";
exports.redA100 = "#ff8a80";
exports.redA200 = "#ff5252";
exports.redA400 = "#ff1744";
exports.redA700 = "#d50000";
exports.pink50 = "#fce4ec";
exports.pink100 = "#f8bbd0";
exports.pink200 = "#f48fb1";
exports.pink300 = "#f06292";
exports.pink400 = "#ec407a";
exports.pink500 = "#e91e63";
exports.pink600 = "#d81b60";
exports.pink700 = "#c2185b";
exports.pink800 = "#ad1457";
exports.pink900 = "#880e4f";
exports.pinkA100 = "#ff80ab";
exports.pinkA200 = "#ff4081";
exports.pinkA400 = "#f50057";
exports.pinkA700 = "#c51162";
exports.purple50 = "#f3e5f5";
exports.purple100 = "#e1bee7";
exports.purple200 = "#ce93d8";
exports.purple300 = "#ba68c8";
exports.purple400 = "#ab47bc";
exports.purple500 = "#9c27b0";
exports.purple600 = "#8e24aa";
exports.purple700 = "#7b1fa2";
exports.purple800 = "#6a1b9a";
exports.purple900 = "#4a148c";
exports.purpleA100 = "#ea80fc";
exports.purpleA200 = "#e040fb";
exports.purpleA400 = "#d500f9";
exports.purpleA700 = "#aa00ff";
exports.deepPurple50 = "#ede7f6";
exports.deepPurple100 = "#d1c4e9";
exports.deepPurple200 = "#b39ddb";
exports.deepPurple300 = "#9575cd";
exports.deepPurple400 = "#7e57c2";
exports.deepPurple500 = "#673ab7";
exports.deepPurple600 = "#5e35b1";
exports.deepPurple700 = "#512da8";
exports.deepPurple800 = "#4527a0";
exports.deepPurple900 = "#311b92";
exports.deepPurpleA100 = "#b388ff";
exports.deepPurpleA200 = "#7c4dff";
exports.deepPurpleA400 = "#651fff";
exports.deepPurpleA700 = "#6200ea";
exports.indigo50 = "#e8eaf6";
exports.indigo100 = "#c5cae9";
exports.indigo200 = "#9fa8da";
exports.indigo300 = "#7986cb";
exports.indigo400 = "#5c6bc0";
exports.indigo500 = "#3f51b5";
exports.indigo600 = "#3949ab";
exports.indigo700 = "#303f9f";
exports.indigo800 = "#283593";
exports.indigo900 = "#1a237e";
exports.indigoA100 = "#8c9eff";
exports.indigoA200 = "#536dfe";
exports.indigoA400 = "#3d5afe";
exports.indigoA700 = "#304ffe";
exports.blue50 = "#e3f2fd";
exports.blue100 = "#bbdefb";
exports.blue200 = "#90caf9";
exports.blue300 = "#64b5f6";
exports.blue400 = "#42a5f5";
exports.blue500 = "#2196f3";
exports.blue600 = "#1e88e5";
exports.blue700 = "#1976d2";
exports.blue800 = "#1565c0";
exports.blue900 = "#0d47a1";
exports.blueA100 = "#82b1ff";
exports.blueA200 = "#448aff";
exports.blueA400 = "#2979ff";
exports.blueA700 = "#2962ff";
exports.lightBlue50 = "#e1f5fe";
exports.lightBlue100 = "#b3e5fc";
exports.lightBlue200 = "#81d4fa";
exports.lightBlue300 = "#4fc3f7";
exports.lightBlue400 = "#29b6f6";
exports.lightBlue500 = "#03a9f4";
exports.lightBlue600 = "#039be5";
exports.lightBlue700 = "#0288d1";
exports.lightBlue800 = "#0277bd";
exports.lightBlue900 = "#01579b";
exports.lightBlueA100 = "#80d8ff";
exports.lightBlueA200 = "#40c4ff";
exports.lightBlueA400 = "#00b0ff";
exports.lightBlueA700 = "#0091ea";
exports.cyan50 = "#e0f7fa";
exports.cyan100 = "#b2ebf2";
exports.cyan200 = "#80deea";
exports.cyan300 = "#4dd0e1";
exports.cyan400 = "#26c6da";
exports.cyan500 = "#00bcd4";
exports.cyan600 = "#00acc1";
exports.cyan700 = "#0097a7";
exports.cyan800 = "#00838f";
exports.cyan900 = "#006064";
exports.cyanA100 = "#84ffff";
exports.cyanA200 = "#18ffff";
exports.cyanA400 = "#00e5ff";
exports.cyanA700 = "#00b8d4";
exports.teal50 = "#e0f2f1";
exports.teal100 = "#b2dfdb";
exports.teal200 = "#80cbc4";
exports.teal300 = "#4db6ac";
exports.teal400 = "#26a69a";
exports.teal500 = "#009688";
exports.teal600 = "#00897b";
exports.teal700 = "#00796b";
exports.teal800 = "#00695c";
exports.teal900 = "#004d40";
exports.tealA100 = "#a7ffeb";
exports.tealA200 = "#64ffda";
exports.tealA400 = "#1de9b6";
exports.tealA700 = "#00bfa5";
exports.green50 = "#e8f5e9";
exports.green100 = "#c8e6c9";
exports.green200 = "#a5d6a7";
exports.green300 = "#81c784";
exports.green400 = "#66bb6a";
exports.green500 = "#4caf50";
exports.green600 = "#43a047";
exports.green700 = "#388e3c";
exports.green800 = "#2e7d32";
exports.green900 = "#1b5e20";
exports.greenA100 = "#b9f6ca";
exports.greenA200 = "#69f0ae";
exports.greenA400 = "#00e676";
exports.greenA700 = "#00c853";
exports.lightGreen50 = "#f1f8e9";
exports.lightGreen100 = "#dcedc8";
exports.lightGreen200 = "#c5e1a5";
exports.lightGreen300 = "#aed581";
exports.lightGreen400 = "#9ccc65";
exports.lightGreen500 = "#8bc34a";
exports.lightGreen600 = "#7cb342";
exports.lightGreen700 = "#689f38";
exports.lightGreen800 = "#558b2f";
exports.lightGreen900 = "#33691e";
exports.lightGreenA100 = "#ccff90";
exports.lightGreenA200 = "#b2ff59";
exports.lightGreenA400 = "#76ff03";
exports.lightGreenA700 = "#64dd17";
exports.lime50 = "#f9fbe7";
exports.lime100 = "#f0f4c3";
exports.lime200 = "#e6ee9c";
exports.lime300 = "#dce775";
exports.lime400 = "#d4e157";
exports.lime500 = "#cddc39";
exports.lime600 = "#c0ca33";
exports.lime700 = "#afb42b";
exports.lime800 = "#9e9d24";
exports.lime900 = "#827717";
exports.limeA100 = "#f4ff81";
exports.limeA200 = "#eeff41";
exports.limeA400 = "#c6ff00";
exports.limeA700 = "#aeea00";
exports.yellow50 = "#fffde7";
exports.yellow100 = "#fff9c4";
exports.yellow200 = "#fff59d";
exports.yellow300 = "#fff176";
exports.yellow400 = "#ffee58";
exports.yellow500 = "#ffeb3b";
exports.yellow600 = "#fdd835";
exports.yellow700 = "#fbc02d";
exports.yellow800 = "#f9a825";
exports.yellow900 = "#f57f17";
exports.yellowA100 = "#ffff8d";
exports.yellowA200 = "#ffff00";
exports.yellowA400 = "#ffea00";
exports.yellowA700 = "#ffd600";
exports.amber50 = "#fff8e1";
exports.amber100 = "#ffecb3";
exports.amber200 = "#ffe082";
exports.amber300 = "#ffd54f";
exports.amber400 = "#ffca28";
exports.amber500 = "#ffc107";
exports.amber600 = "#ffb300";
exports.amber700 = "#ffa000";
exports.amber800 = "#ff8f00";
exports.amber900 = "#ff6f00";
exports.amberA100 = "#ffe57f";
exports.amberA200 = "#ffd740";
exports.amberA400 = "#ffc400";
exports.amberA700 = "#ffab00";
exports.orange50 = "#fff3e0";
exports.orange100 = "#ffe0b2";
exports.orange200 = "#ffcc80";
exports.orange300 = "#ffb74d";
exports.orange400 = "#ffa726";
exports.orange500 = "#ff9800";
exports.orange600 = "#fb8c00";
exports.orange700 = "#f57c00";
exports.orange800 = "#ef6c00";
exports.orange900 = "#e65100";
exports.orangeA100 = "#ffd180";
exports.orangeA200 = "#ffab40";
exports.orangeA400 = "#ff9100";
exports.orangeA700 = "#ff6d00";
exports.deepOrange50 = "#fbe9e7";
exports.deepOrange100 = "#ffccbc";
exports.deepOrange200 = "#ffab91";
exports.deepOrange300 = "#ff8a65";
exports.deepOrange400 = "#ff7043";
exports.deepOrange500 = "#ff5722";
exports.deepOrange600 = "#f4511e";
exports.deepOrange700 = "#e64a19";
exports.deepOrange800 = "#d84315";
exports.deepOrange900 = "#bf360c";
exports.deepOrangeA100 = "#ff9e80";
exports.deepOrangeA200 = "#ff6e40";
exports.deepOrangeA400 = "#ff3d00";
exports.deepOrangeA700 = "#dd2c00";
exports.brown50 = "#efebe9";
exports.brown100 = "#d7ccc8";
exports.brown200 = "#bcaaa4";
exports.brown300 = "#a1887f";
exports.brown400 = "#8d6e63";
exports.brown500 = "#795548";
exports.brown600 = "#6d4c41";
exports.brown700 = "#5d4037";
exports.brown800 = "#4e342e";
exports.brown900 = "#3e2723";
exports.blueGrey50 = "#eceff1";
exports.blueGrey100 = "#cfd8dc";
exports.blueGrey200 = "#b0bec5";
exports.blueGrey300 = "#90a4ae";
exports.blueGrey400 = "#78909c";
exports.blueGrey500 = "#607d8b";
exports.blueGrey600 = "#546e7a";
exports.blueGrey700 = "#455a64";
exports.blueGrey800 = "#37474f";
exports.blueGrey900 = "#263238";
exports.grey50 = "#fafafa";
exports.grey100 = "#f5f5f5";
exports.grey200 = "#eeeeee";
exports.grey300 = "#e0e0e0";
exports.grey400 = "#bdbdbd";
exports.grey500 = "#9e9e9e";
exports.grey600 = "#757575";
exports.grey700 = "#616161";
exports.grey800 = "#424242";
exports.grey900 = "#212121";
exports.black = "#000";
exports.white = "#fff";
exports.transparent = "rgba(0, 0, 0, 0)";
exports.fullBlack = "rgba(0, 0, 0, 1)";
exports.darkBlack = "rgba(0, 0, 0, 0.87)";
exports.lightBlack = "rgba(0, 0, 0, 0.54)";
exports.minBlack = "rgba(0, 0, 0, 0.26)";
exports.faintBlack = "rgba(0, 0, 0, 0.12)";
exports.fullWhite = "rgba(255, 255, 255, 1)";
exports.darkWhite = "rgba(255, 255, 255, 0.87)";
exports.lightWhite = "rgba(255, 255, 255, 0.54)";
//# sourceMappingURL=accentColors.js.map